;(function () {

"use strict";

var ModalView = require('./modal');
var AddNoteForm = require('./templates/add-note-form.html');

var NoteFormModal = ModalView.extend({
  className: 'modal note',
  initialize: function (opts) {
    opts = opts || {};
    this.parent = opts.parent;
    // console.log(this.parent.cart.attributes['gift-note']);
    // console.log(this.parent.cart);
    this.maxlen = opts.maxlen || 150;
    opts.content = _.template(AddNoteForm)({note: this.parent.cart.attributes['gift-note'], maxlen: this.maxlen});
    ModalView.prototype.initialize.call(this, opts);
  },
  success: function () {
    if (this.parent && this.parent.render) {
      this.parent.render();
    }

    this.$el.find('button').addClass('success');
    _.delay(_.bind(function () {
      this.$el.find("button").removeClass('success');
      this.hide();

      /* Show minicart view */
      var view = window.App.dvs['mini-cart'];
      view.mouseenter();
      view.$el.addClass('hover');
    }, this), 2000);    
  },
  complete: function () {
    this.loading = undefined;
  },
  submit: function (e) {
    if (this.loading) { return false; }
    this.$el.removeClass('success');
    this.loading = true;

    var data = {};
    data.attributes = {};
    data.attributes['gift-note'] = this.$el.find('textarea').val();

    $.ajax({
      type: 'POST',
      url: '/cart/update.js', 
      data: data,
      dataType: 'json',
      success: _.bind(this.success, this),
      complete: _.bind(this.complete, this)
    });

    return false;
  },
  update: function (e) {
    var $this = $(e.currentTarget);
    var val = $this.val();
    var $number = $this.parent().find('.max-chars strong');
    var $copy = $this.parent().find('.max-chars span');

    var remaining = this.maxlen - val.length;
    if (remaining < 0) {
      remaining = 0;
    }

    if (remaining === 1) {
      $copy.html('character remaining');
    } else {
      $copy.html('characters remaining');
    }

    $number.html(remaining);

    if (remaining <= 0) {
      $this.val(val.slice(0, this.maxlen));
      return false;
    }
  },
  events: _.extend({}, ModalView.prototype.events, {
    'submit': 'submit',
    'keyup textarea': 'update'
  })
});

var GiftWrapView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.parent = opts.parent;
    this.id = $("#global-data").data('gift-wrap-id');

    /* Remove if only line item in the cart   */
    // if (this.parent.cart.item_count === 1 && this.parent.cart.attributes['gift-wrapping']) {
    //   this.remove();
    // }
  },
  success: function (d) {
    // console.log('success');
    // console.log(d);
    if (this.parent && this.parent.render) {
      this.parent.render();
    }

    /* for cart page only */
    if (d.attributes['gift-wrapping']) {
      this.$el.find('.cart-page-gift-note').addClass('active');
    } else {
      this.$el.find('.cart-page-gift-note').removeClass('active');
    }

    if (this.$el.parent().hasClass('tbody')) {
      window.location.reload();
    }
  },
  complete: function () {
    // console.log('complete');
    this.loading = undefined;
  },
  toggle: function (e) {
    /* 
      REVERT BACK WHEN GIFT WRAP IS BACK
    */
    /*
    if (this.loading) { return false; }

    this.loading = true;

    var $this = $(e.currentTarget);
    var checked = $this.prop('checked');

    // console.log(checked);
    if (checked) {
      this.add();
    } else {
      this.remove();
    }
    */

    this.showNote();

    if (this.parent.cart.attributes['gift-note']) {
      $(e.currentTarget).prop('checked', true);
    } else {
      $(e.currentTarget).prop('checked', false);
    }

    return false;
  },
  add: function () {
    var data = {};
    data.updates = {};
    data.updates[this.id] = 1;
    data.attributes = { 'gift-wrapping': true };

    $.ajax({
      type: 'POST',
      url: '/cart/update.js', 
      data: data,
      dataType: 'json',
      success: _.bind(this.success, this),
      complete: _.bind(this.complete, this)
    });
  },
  remove: function () {
    var data = {};
    data.updates = {};
    data.updates[this.id] = 0;
    data.attributes = { 'gift-wrapping': '' };

    $.ajax({
      type: 'POST',
      url: '/cart/update.js', 
      data: data,
      dataType: 'json',
      success: _.bind(this.success, this),
      complete: _.bind(this.complete, this)
    });
  },
  showNote: function (e) {
    // console.log('showing note');
    new NoteFormModal({parent: this.parent}).render().show();
    return false;
  },
  events: {
    'change input[type="checkbox"]': 'toggle',
    'click span': 'showNote'
  }
});

module.exports = GiftWrapView;

}());